<template>
  <div style="height: 100%">
    <editor-toolbar v-if="editorOpen" />
    <toolbar v-else :title="$t('toolbar.title')" />
    <template-container :page-count="pageCount" v-if="!editorOpen" />
    <editor-container v-else />
    <sweet-modal
      ref="errorModal"
      icon="error"
      @close="setError"
      hide-close-button
    >
      <div v-if="error !== undefined">
        <div v-for="(detail, index) in error.details" :key="index">
          <p v-if="detail.message !== undefined">{{ detail.message }}</p>
          <p
            v-if="
              detail.path !== undefined &&
              detail.path !== null &&
              detail.path != ''
            "
          >
            <strong>{{ $t('errors.field') }}:</strong> {{ detail.path }}
          </p>
        </div>
        <p v-if="error.logref !== undefined">
          <strong>{{ $t('errors.error_code') }}</strong> {{ error.logref }}
        </p>
        <div v-if="error.message !== undefined">
          <div v-for="(message, index) in error.message.data" :key="index">
            <p v-if="message.propertyName !== undefined">
              <strong>{{ message.propertyName }}:</strong>
              {{ message.propertyValue }}
            </p>
            <p v-else>{{ message.propertyValue }}</p>
            <br />
          </div>
        </div>
      </div>
      <p>{{ $t('errors.generic_error') }}</p>
      <p>{{ $t('errors.try_again') }}</p>
      <template #button>
        <button class="btn btn-default right-margin" @click="close">
          {{ $t('modals.close_button') }}
        </button>
      </template>
    </sweet-modal>
    <sweet-modal ref="infoModal" icon="info" @close="setInfo" hide-close-button>
      <div v-if="info !== undefined && info.message !== undefined">
        <br />
        <div v-for="(message, index) in info.message.data" :key="index">
          <p
            v-if="
              message.propertyName !== undefined &&
              message.propertyName.trim() !== ''
            "
          >
            <strong>{{ message.propertyName }}:</strong>
            {{ message.propertyValue }}
          </p>
          <p v-else>{{ message.propertyValue }}</p>
        </div>
      </div>
      <template #button>
        <button class="btn btn-default right-margin" @click="closeInfo">
          {{ $t('modals.close_button') }}
        </button>
      </template>
    </sweet-modal>
    <sweet-modal
      ref="warningModal"
      icon="warning"
      @close="setWarning"
      hide-close-button
    >
      <br />
      <div v-if="warning !== undefined">
        <div v-for="(detail, index) in warning.details" :key="index">
          <p v-if="detail.message !== undefined">{{ detail.message }}</p>
          <p v-if="detail.path !== undefined && detail.path !== null">
            <strong>{{ $t('errors.field') }}:</strong> {{ detail.path }}
          </p>
        </div>
        <br />
        <p v-if="warning.logref !== undefined">
          <strong>{{ $t('errors.error_code') }}</strong> {{ warning.logref }}
        </p>
        <div v-if="warning.message !== undefined">
          <div v-for="(message, index) in warning.message.data" :key="index">
            <p v-if="message.propertyName !== undefined">
              <strong>{{ message.propertyName }}:</strong>
              {{ message.propertyValue }}
            </p>
            <p v-else>{{ message.propertyValue }}</p>
            <br />
          </div>
        </div>
      </div>
      <template #button>
        <button class="btn btn-default right-margin" @click="closeWarning">
          {{ $t('modals.close_button') }}
        </button>
      </template>
    </sweet-modal>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import TemplateContainer from './TemplateContainer.vue';
import EditorContainer from './EditorContainer.vue';
import EditorToolbar from './EditorToolbar.vue';
import Toolbar from './Toolbar.vue';

export default {
  name: 'TemplateSection',
  data: function () {
    return {};
  },
  components: {
    Toolbar,
    TemplateContainer,
    EditorContainer,
    EditorToolbar,
    SweetModal
  },
  computed: {
    ...mapState({
      editorOpen: state => state.editorOpen,
      error: state => state.error,
      info: state => state.info,
      warning: state => state.warning,
      templateData: state => state.templateData,
      pageCount: state => state.pageCount
    })
  },
  watch: {
    error: function (newValue) {
      if (newValue !== undefined) {
        this.$refs.errorModal.open();
      }
    },
    info: function (newValue) {
      if (newValue !== undefined) {
        this.$refs.infoModal.open();
      }
    },
    warning: function (newValue) {
      if (newValue !== undefined) {
        this.$refs.warningModal.open();
      }
    }
  },
  methods: {
    ...mapActions([
      'initCustomTemplate',
      'retrieveLibraries',
      'getTags',
      'retrieveMergeTagsSources'
    ]),
    ...mapMutations(['setError', 'setInfo', 'setWarning']),
    close: function () {
      this.$refs.errorModal.close();
    },
    closeInfo: function () {
      this.$refs.infoModal.close();
    },
    closeWarning: function () {
      this.$refs.warningModal.close();
    }
  },
  mounted: function () {
    this.retrieveLibraries();
    this.getTags();
    this.retrieveMergeTagsSources();
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
